import * as R from 'ramda';

import cursorIcon from '@atom/components/common/svgIcons/mapCursor.svg';
import cursorIconSelected from '@atom/components/common/svgIcons/mapCursorSelected.svg';
import grabIcon from '@atom/components/common/svgIcons/mapGrab.svg';
import grabIconSelected from '@atom/components/common/svgIcons/mapGrabSelected.svg';
import polygonIcon from '@atom/components/common/svgIcons/polygonDraw.svg';
import polygonIconSelected from '@atom/components/common/svgIcons/polygonDrawSelected.svg';
import radiusIcon from '@atom/components/common/svgIcons/radiusDraw.svg';
import radiusIconSelected from '@atom/components/common/svgIcons/radiusDrawSelected.svg';
import { useNavigation } from '@atom/hooks/useNavigation';
import { usePreferences } from '@atom/hooks/usePreferences';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import { MapShapeType } from '@atom/types/map';

import classes from './drawingControls.module.css';
interface Props {
  drawingMode: MapShapeType;
  onChange: (drawingMode: MapShapeType) => void;
  grab: boolean;
  onCursorChange: (cursor: Boolean) => void;
  clearDrawing: () => void;
}

const styles = {
  icon: {
    width: '2.375rem',
    height: '2.375rem',
    padding: '0.4375rem',
    zIndex: '200',
  },
};

const DrawingControls = ({
  drawingMode,
  onChange,
  grab,
  onCursorChange,
  clearDrawing,
}: Props) => {
  const [, { updateSearchParams }] = useNavigation();

  const preferences = usePreferences();
  const enableBulkImplementation = R.pathOr(
    false,
    ['workOrders', 'createBulkWorkFromMap'],
    preferences,
  );

  const handleClick = (mode: MapShapeType) => {
    if (drawingMode === mode) {
      onChange(null);
    } else {
      clearDrawing();
      onChange(mode);
      if (enableBulkImplementation) {
        updateSearchParams({ view: 'list' });
      }
    }
  };

  const handleCursorClick = (value: Boolean) => {
    clearDrawing();
    onCursorChange(value);
  };

  return (
    <>
      <div className={classes.layerControlsContainer}>
        <div className={classes.iconContainer}>
          <IconButton
            tooltip="Select"
            style={styles.icon}
            onClick={() => handleCursorClick(false)}
          >
            <Icon>
              <img src={grab ? cursorIcon : cursorIconSelected} alt="Cursor" />
            </Icon>
          </IconButton>
        </div>
        <div className={classes.iconContainer}>
          <IconButton
            tooltip="Grab"
            style={styles.icon}
            onClick={() => handleCursorClick(true)}
          >
            <Icon>
              <img src={grab ? grabIconSelected : grabIcon} alt="Draw Radius" />
            </Icon>
          </IconButton>
        </div>
        <div className={classes.iconContainer}>
          <IconButton
            tooltip="Draw a radius"
            style={styles.icon}
            onClick={() => handleClick(MapShapeType.CIRCLE)}
          >
            <Icon>
              <img
                src={
                  drawingMode === MapShapeType.CIRCLE
                    ? radiusIconSelected
                    : radiusIcon
                }
                alt="Draw Radius"
              />
            </Icon>
          </IconButton>
        </div>
        <div className={classes.iconContainer}>
          <IconButton
            tooltip="Draw a polygon"
            style={styles.icon}
            onClick={() => handleClick(MapShapeType.POLYGON)}
          >
            <Icon>
              <img
                src={
                  drawingMode === MapShapeType.POLYGON
                    ? polygonIconSelected
                    : polygonIcon
                }
                alt="Draw Polygon"
              />
            </Icon>
          </IconButton>
        </div>
        <div className={classes.iconContainer}>
          <IconButton
            tooltip="Measure distance"
            style={styles.icon}
            onClick={() => handleClick(MapShapeType.POLYLINE)}
          >
            <Icon
              color={
                drawingMode === MapShapeType.POLYLINE
                  ? colors.brand.blue
                  : colors.neutral.gray
              }
            >
              straighten
            </Icon>
          </IconButton>
        </div>
      </div>
    </>
  );
};

export default DrawingControls;
